<template>
  <div>
    <a class="card article" :href="article.url">
      <div class="card-image" v-if="article.desktop_image">
        <figure class="image is-4by3">
          <responsive-image :desktop="article.desktop_image" :tablet="article.tablet_image" :mobile="article.mobile_image" :blurred="article.blurred_image" lazy/>
        </figure>
      </div>

      <div class="card-content" :style="{'background-color': article.image_color}">
        <div class="content">
          <h2>{{ article.name }}</h2>
          <p>{{ article.description }}</p>
          <timeago :since="article.created_at" :title="article.created_at | date('DD.MM.YYYY')" v-if="article.created_at">
            {{ article.created_at | date('DD.MM.YYYY') }}
          </timeago>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import Vue from 'vue'
import filters from 'shared/filters'
import ResponsiveImage from '../../ResponsiveImage.vue'

Vue.use(filters)

export default {
  props: {
    article: {type: Object, default: () => ({})}
  },

  components: {
    ResponsiveImage
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/blog/article/Preview.vue